import { useState, useEffect } from "react";

const useFilePreview = (file: File | null) => {
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setPreview(null); // Clear preview if no file is selected
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result as string); // Set the preview URL
    };
    reader.readAsDataURL(file); // Read file as data URL

    return () => {
      if (preview) {
        URL.revokeObjectURL(preview); // Cleanup URL to avoid memory leaks
      }
    };
  }, [file, preview]);

  return preview;
};

export default useFilePreview;
